import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import { MeWithIdentities } from '../graphql/queries/account';
import { photosUpload } from '../graphql/mutations/photos';
import {
  identityUpdate as identityUpdateMutation,
  updateSelfie,
} from '../graphql/mutations/identity';
import {
  identityUpdate,
  identityUpdateResetAction,
} from '../redux/actions/identity-update';
import UpdateAccountIdentityModal from '../components/UpdateAccountIdentity';
import { openModal } from '../../../actions/modal-actions';

const withUserData = graphql(MeWithIdentities, {
  props: ({ data: { me } }) => ({
    account: me,
  }),
});

const withPhotosUpload = graphql(photosUpload, {
  props: ({ mutate }) => ({
    photosUploadMutation: (accountId, files) =>
      mutate({
        variables: {
          input: {
            account_id: accountId,
            files,
            selfie_verify: true,
          },
        },
      }),
  }),
});

const withIdentityUpdate = graphql(identityUpdateMutation, {
  props: ({ mutate }) => ({
    identityUpdateMutation: ({ identityId, firstName, lastName, gender }) =>
      mutate({
        variables: {
          input: {
            id: identityId,
            name: firstName,
            last_name: lastName,
            gender,
          },
        },
      }),
  }),
});

const withUpdateSelfie = graphql(updateSelfie, {
  props: ({ mutate }) => ({
    updateSelfieMutation: (identityId, photoId) =>
      mutate({
        variables: {
          input: {
            identity_id: identityId,
            photo_id: photoId,
            selfie_verify: true,
          },
        },
      }),
  }),
});

const mapStateToProps = ({ identityUpdate: identityUpdateData }) => ({
  loading: identityUpdateData.loading,
  error: identityUpdateData.error,
  success: identityUpdateData.success,
});

const mapDispatchToProps = {
  identityUpdate,
  identityUpdateReset: identityUpdateResetAction,
  openModal,
};

export default compose(
  withRouter,
  withUserData,
  withPhotosUpload,
  withIdentityUpdate,
  withUpdateSelfie,
  connect(mapStateToProps, mapDispatchToProps),
)(UpdateAccountIdentityModal);
